import { render, staticRenderFns } from "./DashboardEnrollmentRenewPlan.vue?vue&type=template&id=6710d938&scoped=true"
import script from "./DashboardEnrollmentRenewPlan.vue?vue&type=script&lang=js"
export * from "./DashboardEnrollmentRenewPlan.vue?vue&type=script&lang=js"
import style0 from "./DashboardEnrollmentRenewPlan.vue?vue&type=style&index=0&id=6710d938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710d938",
  null
  
)

export default component.exports